/* eslint no-shadow: 0 */

import { ERROR, HIDE_ERROR, RESPONSE_ERROR, SUCCESS, HIDE_SUCCESS, RESPONSE_SUCCESS, SUCCESS_WITH_OPTIONS } from '../actions/ui';

const state = {
  error: null,
  success: null,
  successDismissible: false,
};

const getters = {
  error: (state) => state.error,
  success: (state) => state.success,
  successDismissible: (state) => state.successDismissible,
};

const actions = {
  [RESPONSE_ERROR]: ({ dispatch }, error) => {
    let message = error;
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    }
    dispatch(ERROR, message);
  },
  [ERROR]: ({ commit }, message) => {
    commit(ERROR, message);
    setTimeout(() => {
      commit(HIDE_ERROR);
    }, 8000);
  },
  [HIDE_ERROR]: ({ commit }) => {
    commit(HIDE_ERROR);
  },
  [RESPONSE_SUCCESS]: ({ dispatch }, success) => {
    let message = success;
    if (success.response && success.response.data && success.response.data.message) {
      message = success.response.data.message;
    }
    dispatch(SUCCESS, message);
  },
  [SUCCESS]: ({ commit }, message) => {
    commit(SUCCESS, message);
    setTimeout(() => {
      commit(HIDE_SUCCESS);
    }, 3000);
  },
  [SUCCESS_WITH_OPTIONS]: ({ commit }, { message, timing = 3000, dismissible = false }) => {
    commit(SUCCESS_WITH_OPTIONS, { message, dismissible });
    setTimeout(() => {
      commit(HIDE_SUCCESS);
    }, timing);
  },
  [HIDE_SUCCESS]: ({ commit }) => {
    commit(HIDE_SUCCESS);
  },
};

const mutations = {
  [ERROR]: (state, message) => {
    state.error = message;
  },
  [HIDE_ERROR]: (state) => {
    state.error = null;
  },
  [SUCCESS]: (state, message) => {
    state.success = message;
    state.successDismissible = false;
  },
  [SUCCESS_WITH_OPTIONS]: (state, { message, dismissible }) => {
    state.success = message;
    state.successDismissible = dismissible;
  },
  [HIDE_SUCCESS]: (state) => {
    state.success = null;
    state.successDismissible = false;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
